// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"428":"b8179f72","500":"cc15363b"}[chunkId] + ".chunk.js";
};